import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import DevTools from '../../components/DevTools';
import { NotaryServiceComponent } from '../../components/SmartComply/NotaryService/NotaryServiceComponent';
import './AdminLayout.css';

const AdminLayout = () => {
  const location = useLocation();
  const [sponsFIExpanded, setSponsFIExpanded] = useState(false);
  const [messagesExpanded, setMessagesExpanded] = useState(false);
  
  console.log('AdminLayout rendering'); 

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <nav>
          <ul>
            {/* Operations */}
            <li className={location.pathname.includes('/dashboard') ? 'active' : ''}>
              <Link to="/portal/admin/dashboard">
                <i className="fas fa-building"></i>
                Operations
              </Link>
            </li>
            
            {/* Analytics */}
            <li className={location.pathname.includes('/analytics') ? 'active' : ''}>
              <Link to="/portal/admin/analytics">
                <i className="fas fa-chart-line"></i>
                Analytics
              </Link>
            </li>

            {/* SponsFI with subnav */}
            <li className={location.pathname.includes('/sponsfi') ? 'active' : ''}>
              <button 
                className="nav-button"
                onClick={() => setSponsFIExpanded(!sponsFIExpanded)}
              >
                <i className="fas fa-university"></i>
                SponsFI
                <i className={`fas fa-chevron-${sponsFIExpanded ? 'down' : 'right'} chevron`}></i>
              </button>
              
              {sponsFIExpanded && (
                <ul className="subnav">
                  <li>
                    <Link 
                      to="/portal/admin/sponsfi/overview"
                      className={location.pathname.includes('/sponsfi/overview') ? 'active' : ''}
                    >
                      <i className="fas fa-chart-line"></i>
                      Overview
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/portal/admin/sponsfi/accounting"
                      className={location.pathname.includes('/sponsfi/accounting') ? 'active' : ''}
                    >
                      Accounting
                    </Link>
                  </li>
                  <li>
                    <Link to="/portal/admin/sponsfi/reports">Reports</Link>
                  </li>
                  <li>
                    <Link 
                      to="/portal/admin/sponsfi/compliance"
                      className={location.pathname.includes('/sponsfi/compliance') && !location.pathname.includes('/notary') ? 'active' : ''}
                    >
                      <i className="fas fa-shield-alt"></i>
                      Compliance
                    </Link>
                    <ul className="subnav">
                      <li>
                        <Link 
                          to="/portal/admin/sponsfi/compliance/notary"
                          className={location.pathname.includes('/sponsfi/compliance/notary') ? 'active' : ''}
                        >
                          <i className="fas fa-stamp"></i>
                          Notary Service
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/portal/admin/sponsfi/grants">Grants</Link>
                  </li>
                  <li>
                    <Link to="/portal/admin/sponsfi/settings">Settings</Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Messages with subnav */}
            <li className={location.pathname.includes('/messages') ? 'active' : ''}>
              <button 
                className="nav-button"
                onClick={() => setMessagesExpanded(!messagesExpanded)}
              >
                <i className="fas fa-comments"></i>
                Messages
                <i className={`fas fa-chevron-${messagesExpanded ? 'down' : 'right'} chevron`}></i>
              </button>
              
              {messagesExpanded && (
                <ul className="subnav">
                  <li>
                    <Link 
                      to="/portal/admin/messages/inbox"
                      className={location.pathname.includes('/messages/inbox') ? 'active' : ''}
                    >
                      <i className="fas fa-inbox"></i>
                      Smart Inbox
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/portal/admin/messages/cases"
                      className={location.pathname.includes('/messages/cases') ? 'active' : ''}
                    >
                      <i className="fas fa-folder-open"></i>
                      Cases
                    </Link>
                  </li>
                  <li>
                    <Link to="/portal/admin/messages/tasks">
                      <i className="fas fa-tasks"></i>
                      Tasks
                    </Link>
                  </li>
                  <li>
                    <Link to="/portal/admin/messages/archive">
                      <i className="fas fa-archive"></i>
                      Archive
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Smart Comply */}
            <li className={location.pathname.includes('/smart-comply') ? 'active' : ''}>
              <Link to="/portal/admin/smart-comply">
                <i className="fas fa-shield-check"></i>
                Smart Comply
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="admin-content">
        <Outlet />
        {location.pathname.includes('/sponsfi/compliance/notary') && <NotaryServiceComponent />}
      </div>
      {process.env.NODE_ENV === 'development' && <DevTools />}
    </div>
  );
};

export default AdminLayout; 